module.exports = __webpack_public_path__ + "static/media/carrito.8bb492c8.svg";